/* eslint-disable no-empty-function */
/* eslint-disable no-shadow */
/* eslint-disable new-cap */
/* eslint-disable no-new */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import { Howl, Howler } from 'howler';
// import weChatShare from '../assets/plugins/weChatShare/weChatShare.js';

import backMusic from '../assets/media/background/food_wys_guilinggao_happy.wav';

import cg1 from '../assets/media/cg_anniversary_0003/cg_role_153_0014.wav';
import cg2 from '../assets/media/cg_anniversary_0003/cg_role_178_0004.wav';
import cg3 from '../assets/media/cg_anniversary_0003/cg_role_178_0005.wav';
import cg4 from '../assets/media/cg_anniversary_0003/cg_role_153_0015.wav';
import cg5 from '../assets/media/cg_anniversary_0003/cg_role_178_0006.wav';
import cg6 from '../assets/media/cg_anniversary_0003/cg_role_153_0016.wav';
import cg7 from '../assets/media/cg_anniversary_0003/cg_role_260_0007.wav';
import cg8 from '../assets/media/cg_anniversary_0003/cg_role_178_0007.wav';
import cg9 from '../assets/media/cg_anniversary_0003/cg_role_153_0017.wav';
import cg10 from '../assets/media/cg_anniversary_0003/cg_role_260_0008.wav';
import cg11 from '../assets/media/cg_anniversary_0003/cg_role_178_0008.wav';

import '../assets/plugins/leaf/css/style.css';

// import vConsole from 'vconsole';
// new vConsole();

const subTitleArr = [
  {
    cg: cg1,
    role: '北京烤鸭',
    txt: '好吧，我收回刚才的话。'
  },
  {
    cg: cg2,
    role: '鱼香肉丝',
    txt: '过年就是要热闹一点才好嘛。'
  },
  {
    cg: cg3,
    role: '鱼香肉丝',
    txt: '不过看样子，龙凤烩这次是闯了大祸了吧。'
  },
  {
    cg: cg4,
    role: '北京烤鸭',
    txt: '哦？我看这两人倒是和平日里没什么两样。'
  },
  {
    cg: cg5,
    role: '鱼香肉丝',
    txt: '我还没见过雄黄酒的这个样子呢，要不要去拦着点儿。'
  },
  {
    cg: cg6,
    role: '北京烤鸭',
    txt: '倒也不必。'
  },
  {
    cg: cg7,
    role: '西湖龙井',
    txt: '嗯……雄黄酒他，并没有真的生气。'
  },
  {
    cg: cg8,
    role: '鱼香肉丝',
    txt: '……你们两个倒是不急，还一唱一和起来了。'
  },
  {
    cg: cg9,
    role: '北京烤鸭',
    txt: '（轻笑）反正闹起来了，拆的也不是我的亭子。'
  },
  {
    cg: cg10,
    role: '西湖龙井',
    txt: '……不会至此。'
  },
  {
    cg: cg11,
    role: '鱼香肉丝',
    txt: '我看天塌了你们俩都不会眨眨眼睛吧。'
  }
];

const leaf = () => {
  let wh = $(window).height();
  setInterval(function () {
    let f =
      $(window).height() > $(window).width()
        ? $(document).height()
        : $(document).width();
    let e = Math.random() * f - 100; // 雪花的定位left值
    let o = 0.3 + Math.random(); // 雪花的透明度
    let fon = (Math.random() + 1).toFixed(2); // 雪花大小
    let l = e - 100 + 300 * Math.random(); // 雪花的横向位移
    let k = 4000 + 5000 * Math.random();
    let html;
    let deg = Math.floor(Math.random() * 360 + 1);
    switch (Math.floor(Math.random() * 8 + 1)) {
      case 1:
        html = "<div class='leaf_1'><div>";
        break;
      case 2:
        html = "<div class='leaf_2'><div>";
        break;
      case 3:
        html = "<div class='leaf_3'><div>";
        break;
      case 4:
        html = "<div class='leaf_4'><div>";
        break;
      case 5:
        html = "<div class='leaf_5'><div>";
        break;
      case 6:
        html = "<div class='leaf_6'><div>";
        break;
      case 7:
        html = "<div class='leaf_5'><div>";
        break;
      case 8:
        html = "<div class='leaf_6'><div>";
        break;
      default:
        break;
    }
    $(html)
      .clone()
      .appendTo('.falling-leaves')
      .css({
        top: -100,
        left: e + 'px',
        // opacity:o,
        // 'font-size':fon,
        transform: `rotate(${deg}deg) scale(${fon})`
      })
      .animate(
        {
          top: wh * 2 + 'px',
          left: l + 'px'
          // opacity:0.3,
        },
        k,
        'linear',
        function () {
          $(this).remove();
        }
      );
  }, 250);
};

const setWeiboShare = options => {
  const opts = {
    url: '',
    appkey: '',
    title: '',
    pic: '',
    relateUid: '',
    language: '',
    ...options
  };
  let txt = 'https://service.weibo.com/share/mobile.php?';
  Object.keys(opts).forEach(keyName => {
    txt += keyName + '=' + encodeURIComponent(opts[keyName]) + '&';
  });

  $('.j_wbshare').attr('href', txt);
};

$(function () {
  const num = 3;
  $('.falling-leaves').addClass(`fenxiang${num}`);
  leaf();
  // LEAF();
  let width = document.documentElement.clientWidth;
  let height = document.documentElement.clientHeight;
  const print = $('.falling-leaves');
  if (width < height) {
    print.width(height);
    print.height(width);
    print.css('top', (height - width) / 2);
    print.css('left', 0 - (height - width) / 2);
    print.css('transform', 'rotate(90deg)');
    print.css('transform-origin', '50% 50%');
  }

  let evt = 'onorientationchange' in window ? 'orientationchange' : 'resize';

  window.addEventListener(
    evt,
    function () {
      console.log(evt);
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      const print = $('.falling-leaves');
      if (width > height) {
        print.width(width);
        print.height(height);
        print.css('top', 0);
        print.css('left', 0);
        print.css('transform', 'none');
        print.css('transform-origin', '50% 50%');
      } else {
        print.width(height);
        print.height(width);
        print.css('top', (height - width) / 2);
        print.css('left', 0 - (height - width) / 2);
        print.css('transform', 'rotate(90deg)');
        print.css('transform-origin', '50% 50%');
      }
    },
    false
  );

  // weChatShare({
  //   title: '除夕，我在约定之地等您。',
  //   desc: '三人在小亭内聊天，远远地就听到雄黄酒和龙凤烩的对话'
  //   // imgUrl: window.location.origin + icon_ky
  // });

  let backFlag = null;
  const $anim = $('.j_anim');
  const $sub1 = $('.j_sub1');
  const $sub2 = $('.j_sub2');

  let backM = new Howl({
    src: [backMusic],
    // html5: true,
    // autoplay: true,
    loop: true,
    volume: 0.5,
    onend: function () {
      console.log('Finished!');
    },
    onload: () => { }
  });

  document.addEventListener('touchstart', function () {
    if (!backFlag) {
      backFlag = backM.play();
    }
    if (!subTitleArr[0].start) {
      subTitleArr[0].audio.play();
    }
  });

  if (window.isWeChat()) {
    $('.btn3').remove();
    // document.addEventListener('WeixinJSBridgeReady', () => {
    //   backM.play();
    //   subTitleArr[0].audio.play();
    // });
  }

  subTitleArr.forEach((item, index) => {
    item.audio = new Howl({
      src: [item.cg],
      // html5: false,
      // autoplay: false,
      loop: false,
      volume: 0.5,
      onplay: () => {
        item.start = true;
        if (item.multiRow) {
          $sub2.html(`<p><span>${item.role}：</span>${item.txt}</p>`);
        } else {
          $sub2.html(`<span>${item.role}：</span>${item.txt}`);
        }
        $anim.animate(
          {
            top: -$anim.height() / 2
          },
          500
        );
      },
      onend: () => {
        if (subTitleArr[index + 1]) {
          subTitleArr[index + 1].audio.play();
          $anim.css('top', 0);
          if (item.multiRow) {
            $sub1.html(`<p><span>${item.role}：</span>${item.txt}</p>`);
          } else {
            $sub1.html(`<span>${item.role}：</span>${item.txt}`);
          }
        } else {
          $('.share')
            .show()
            .animate(
              {
                opacity: 1
              },
              500
            );
          $('.btn_download')
            .show()
            .animate(
              {
                opacity: 1
              },
              500
            );
        }
      },
      onload: () => {
        // item.audio.play();
      }
    });
  });

  $('.btn1').on('click', () => {
    $('.share')
      .hide()
      .css({
        opacity: 0
      });
    $('.btn_download')
      .hide()
      .css({
        opacity: 0
      });
    subTitleArr[0].audio.play();
  });

  $('.btn2').on('click', () => {
    $('.mask')
      .show()
      .animate(
        {
          opacity: 1
        },
        500
      );
  });

  $('.mask').on('click', () => {
    $('.mask')
      .hide()
      .css({
        opacity: 0
      });
  });

  setWeiboShare({
    appkey: 856354796,
    url: 'http://food.funtoygame.com',
    title:
      '%E9%A3%9F%E4%B9%8B%E5%A5%91%E7%BA%A6%E4%B8%A4%E5%91%A8%E5%B9%B4%E5%BA%86%EF%BC%81%EF%BC%81%EF%BC%81%23%E9%A3%9F%E4%B9%8B%E5%A5%91%E7%BA%A6%23%E8%B6%85%E5%A4%9A%E7%A6%8F%E5%88%A9%EF%BC%8C%E5%85%A8%E6%96%B0%E7%AB%A5%E8%AF%9D%E5%89%AF%E6%9C%AC%E6%9D%A5%E4%B8%B4%EF%BC%8C%E4%B8%80%E8%B5%B7%E6%8C%91%E6%88%98%E8%B6%85%E7%BA%A7BOSS%EF%BC%8C%E5%94%AF%E7%BE%8E%E5%A4%96%E8%A7%82%EF%BC%8C%E8%B6%85%E9%AB%98%E5%93%81%E9%98%B6%E9%A3%A8%E7%81%B5%E7%AD%89%E5%BE%85%E5%BE%A1%E4%BE%8D%E5%A4%A7%E4%BA%BA%E7%9A%84%E5%85%89%E4%B8%B4%EF%BC%81'
  });
});
